import cn from "clsx"
import { Typography } from "@callcenter/design-system"

import { useMenuItems } from "../../shared/hooks"
import { isMenuGroupActive, isMenuItemActive } from "../../shared/helpers"

import styles from "./navigation-desktop.module.pcss"
import sharedStyles from "../../shared/styles.module.pcss"

export const NavigationDesktop = () => {
  const menuItems = useMenuItems()

  return (
    <div className={styles.mainMenu}>
      {menuItems.map((item) => (
        <div
          data-key={item.key}
          className={cn(sharedStyles.menuGroup, {
            [sharedStyles.active]: isMenuGroupActive(item)
          })}
          key={item.key}
        >
          <Typography.TopHeader className={sharedStyles.menuGroupLabel}>
            {item.icon}
            {item.label}
          </Typography.TopHeader>
          <div className={cn(sharedStyles.dropdownMenu, styles.dropdownMenu)}>
            {item.children?.map((menuItem) => (
              <Typography.TopHeader
                as="a"
                href={menuItem.path}
                key={menuItem.path}
                className={cn(sharedStyles.menuItem, { [sharedStyles.active]: isMenuItemActive(menuItem) })}
              >
                {menuItem.label}
                {menuItem.badge}
              </Typography.TopHeader>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
